import { render, staticRenderFns } from "./FormBuilderDemo.vue?vue&type=template&id=3bbe6e61&scoped=true&"
import script from "./FormBuilderDemo.vue?vue&type=script&lang=js&"
export * from "./FormBuilderDemo.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderDemo.vue?vue&type=style&index=0&id=3bbe6e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe6e61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbe6e61')) {
      api.createRecord('3bbe6e61', component.options)
    } else {
      api.reload('3bbe6e61', component.options)
    }
    module.hot.accept("./FormBuilderDemo.vue?vue&type=template&id=3bbe6e61&scoped=true&", function () {
      api.rerender('3bbe6e61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/formBuilder/vistas/FormBuilderDemo.vue"
export default component.exports